import { interpolate } from '../../global';
import type { ILanguageResources, ITranslationModule } from '../../interfaces';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.quotes.QuoteHelperFunctions.';
  public static readonly draft = `${Id.prefix}draft`;
  public static readonly estimateAbbrev = `${Id.prefix}estimateAbbrev`;
  public static readonly quoteAbbrev = `${Id.prefix}quoteAbbrev`;
  public static readonly displaySampleAbbrev = `${Id.prefix}displaySampleAbbrev`;
  public static readonly warrantyItemAbbrev = `${Id.prefix}warrantyItemAbbrev`;
  public static readonly estimate = `${Id.prefix}estimate`;
  public static readonly displaySample = `${Id.prefix}displaySample`;
  public static readonly quote = `${Id.prefix}quote`;
  public static readonly warrantyItem = `${Id.prefix}warrantyItem`;
  public static readonly processingPleaseWait = `${Id.prefix}processingPleaseWait`;
  public static readonly waitingForQuoteCopyToComplete = `${Id.prefix}waitingForQuoteCopyToComplete`;
  public static readonly dontWait = `${Id.prefix}dontWait`;
  public static readonly quoteCopyComplete = `${Id.prefix}quoteCopyComplete`;
  public static readonly openQuote = `${Id.prefix}openQuote`;
}

export class LangQuoteHelperFunctions {
  private constructor() {}
  public static draft(): string {
    return interpolate(Id.draft);
  }
  public static estimateAbbrev(): string {
    return interpolate(Id.estimateAbbrev);
  }
  public static quoteAbbrev(): string {
    return interpolate(Id.quoteAbbrev);
  }
  public static displaySampleAbbrev(): string {
    return interpolate(Id.displaySampleAbbrev);
  }
  public static warrantyItemAbbrev(): string {
    return interpolate(Id.warrantyItemAbbrev);
  }
  public static estimate(): string {
    return interpolate(Id.estimate);
  }
  public static displaySample(): string {
    return interpolate(Id.displaySample);
  }
  public static quote(): string {
    return interpolate(Id.quote);
  }
  public static warrantyItem(): string {
    return interpolate(Id.warrantyItem);
  }
  public static processingPleaseWait(): string {
    return interpolate(Id.processingPleaseWait);
  }
  public static waitingForQuoteCopyToComplete(completed: boolean): string {
    return interpolate(Id.waitingForQuoteCopyToComplete, null, completed ? 'completed' : undefined);
  }
  public static dontWait(): string {
    return interpolate(Id.dontWait);
  }
  public static quoteCopyComplete(): string {
    return interpolate(Id.quoteCopyComplete);
  }
  public static openQuote(): string {
    return interpolate(Id.openQuote);
  }
}

export class QuoteHelperFunctionsModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.draft, 'Draft', 'Label for draft quote');
    register.add(Id.estimateAbbrev, "{{glossary 'estimate-abbrev'}}", 'Abbreviation for estimate');
    register.add(Id.quoteAbbrev, "{{glossary 'quote-abbrev'}}", 'Abbreviation for quote');
    register.add(Id.displaySampleAbbrev, "{{glossary 'display-sample-abbrev'}}", 'Abbreviation for display sample');
    register.add(Id.warrantyItemAbbrev, "{{glossary 'warranty-item-abbrev'}}", 'Abbreviation for warranty item');
    register.add(Id.estimate, "{{glossary 'estimate'}}", 'Label for estimate');
    register.add(Id.displaySample, "{{glossary 'display-sample'}}", 'Label for display sample');
    register.add(Id.quote, "{{glossary 'quote'}}", 'Label for quote');
    register.add(Id.warrantyItem, "{{glossary 'warranty-item'}}", 'Label for warranty item');
    register.add(
      Id.processingPleaseWait,
      'Processing, please wait...',
      'Title shown while waiting for an operation to complete'
    );
    register
      .add(
        Id.waitingForQuoteCopyToComplete,
        "We are copying your {{glossary 'quote'}} and it will open automatically when complete. If you close this dialog, you will be notified when your copy is ready.",
        'Message explaining that the quote copy is in progress and will open when done'
      )
      .addSegment('completed', " Your {{glossary 'quote'}} is ready to open.");
    register.add(
      Id.dontWait,
      "Don't Wait",
      'Button label to close the dialog without waiting for the copy to complete'
    );
    register.add(
      Id.quoteCopyComplete,
      "{{glossary 'quote'}} Copy Complete",
      'Title shown when the quote copy operation has completed'
    );
    register.add(Id.openQuote, "Open {{glossary 'quote'}}", 'Button label to open the copied quote');
  }
}
